var _defs, _rect, _polygon, _rect2, _rect3, _polygon2, _polygon3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _rect4, _rect5, _rect6, _line8, _line9, _line10, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpLeafletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.e,.f,.j{fill-rule:evenodd;}.c{fill:#fff;}.d,.j{fill:#ffefe0;}.e,.h{fill:#89d9fb;}.f,.g,.h,.i,.j{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.i{fill:#3ca4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-leaflet-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "33 15.84 113 15.84 113 111.16 94 130.16 33 130.16 33 15.84"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 27,
    y: 9.84,
    width: 80,
    height: 80.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 67,
    y: 9.84,
    width: 40,
    height: 80.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "27 90.04 107 90.04 107 105.16 88 124.16 27 124.16 27 90.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "27 9.84 107 9.84 107 105.16 88 124.16 27 124.16 27 9.84"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 36.04,
    y1: 100.7,
    x2: 59.2,
    y2: 100.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 36.04,
    y1: 107.1,
    x2: 78.54,
    y2: 107.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 70.81,
    y1: 113.5,
    x2: 78.54,
    y2: 113.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 66.13,
    y1: 100.7,
    x2: 78.54,
    y2: 100.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 36.04,
    y1: 113.5,
    x2: 49.87,
    y2: 113.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 55.33,
    y1: 113.5,
    x2: 63.07,
    y2: 113.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 27,
    y1: 90.04,
    x2: 107,
    y2: 90.04
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 36.04,
    y: 22.22,
    width: 36.63,
    height: 36.63
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 79.65,
    y: 22.22,
    width: 18.31,
    height: 18.31
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 79.65,
    y: 47.73,
    width: 18.31,
    height: 18.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 36.04,
    y1: 72.45,
    x2: 72.67,
    y2: 72.45
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 36.04,
    y1: 78.85,
    x2: 72.67,
    y2: 78.85
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 81.78,
    y1: 78.85,
    x2: 97.96,
    y2: 78.85
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "88 124.16 88 105.16 107 105.16 88 124.16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpLeafletIcon);
export default __webpack_public_path__ + "static/media/CP-leaflet-icon.479820107d22b162296e224df98058ae.svg";
export { ForwardRef as ReactComponent };